module.exports = __webpack_public_path__ + "img/user-photo-input.20244080.png";